<template>
  <div class="cropp-image" :style="{ transform: 'scale(' + imgConfig.scale + ')' }">
    <div :style="imgConfig.mainStyle">
      <img
        class="cropped-image"
        id="img-answer"
        v-if="objTest(imgConfig)"
        :src="giveMeImagePlease(imgConfig.src)"
        @mousemove.self="onMouseMove($event)"
        @mouseenter="zoomShow = true"
        @mouseleave="zoomShow = false"
        @load="loadImg($event)"
        :style="[
          {
            'object-position':
              (imgConfig.cropp.pos.x || 0) +
              (imgConfig.cropp.pos.unit + ' ' || '% ') +
              (imgConfig.cropp.pos.y || 0) +
              (imgConfig.cropp.pos.unit || '%'),
            width: imgConfig.cropp.width + 'px',
            height: imgConfig.cropp.height + 'px',
            transform: 'scale(' + scale + ')',
          },
          imgConfig.zoom ? {} : { cursor: 'auto' },
          imgConfig.cssStyle,
        ]"
      />
    </div>
    <div
      @mouseenter="changePosition = !changePosition"
      v-if="imgConfig.zoom && tmpZoom"
      style="position: fixed; background-repeat: no-repeat"
      :style="[
        {
          width: size * 2 + 'px',
          height: size * 2 + 'px',
          top: (1080 - size * 2) / 2 + 'px',
          transform: 'scale(' + zoom + ')',
          right: (1920 / 2 - size * 2) / 2 + 'px',
          'transform-origin': 'center center',
        },
      ]"
    >
      <img
        class="zoomed-image"
        :src="giveMeImagePlease(imgConfig.src)"
        :style="[
          {
            'object-position': left + '% ' + top + '%',
            width: size * 2 + 'px',
            height: size * 2 + 'px',
          },
        ]"
      />
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'cropp-image',
  props: {
    mainConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
    imgConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
      zoomPosiotion: {
        left: 0,
        top: 0,
      },
      size: 100,
      zoom: 3,
      scale: 1,
      zoomShow: false,
      changePosition: false,
      tmpZoom: true,
    };
  },
  created() {},
  beforeDestroy() {
    if (this.tmpZoom == false) {
      this.imgConfig.zoom = true;
    }
  },
  mounted() {
    if (this.imgConfig.zoom) {
      if (this.imgConfig.cropp.height < 200) {
        this.scale = 150 / this.imgConfig.cropp.height;
        this.tmpZoom = false;
        this.imgConfig.zoom = false;
        if (this.imgConfig.cropp.width * this.scale > 1900) {
          this.scale = 1800 / this.imgConfig.cropp.width;
        }
        if (this.scale > 2.7) {
          this.scale = 2.7;
        }
      }
    }
  },
  methods: {
    handleOk(e) {
      return this.$emit('set-width');
    },
    loadImg(e) {
      let $innerWindow = $('.game-scaleable-wrapper');
      let $el = $('#answer-modal');
      let el = document.getElementById('answer-modal');
      let img = document.getElementById('img-answer');
      let elHeight = $el.outerHeight();
      let elWidth = $el.outerWidth();
      let scale;
      scale = Math.min($innerWindow.width() / elWidth, $innerWindow.height() / elHeight);
      this.top =
        ((this.imgConfig.cropp.pos.y * -1) / (img.naturalHeight - this.size * 2)) * 100 +
        (((img.height * scale) / img.naturalHeight) *
          100 *
          (((img.offsetTop -
            ($innerWindow.height() - $el.height() * scale) / 2 -
            img.offsetTop * scale -
            this.size / 2) /
            (img.height * scale)) *
            100)) /
          100;
      this.left =
        ((this.imgConfig.cropp.pos.x * -1) / (img.naturalWidth - this.size * 2)) * 100 +
        (((img.width * scale) / img.naturalWidth) *
          100 *
          (((img.offsetLeft - ($innerWindow.width() - $el.width() * scale) / 2 - img.offsetLeft * scale) /
            (img.width * scale)) *
            100)) /
          100;
    },
    onMouseMove(e) {
      let $innerWindow = $('.game-scaleable-wrapper');
      let $el = $('#answer-modal');
      let el = document.getElementById('answer-modal');
      let elHeight = $el.outerHeight();
      let elWidth = $el.outerWidth();
      let scale;
      scale = Math.min($innerWindow.width() / elWidth, $innerWindow.height() / elHeight);
      console.log((((this.size * 2 * scale) / e.target.naturalWidth) * 100) / 2);
      if (
        (100 *
          (((e.pageY -
            ($innerWindow.height() - $el.height() * scale) / 2 -
            e.target.offsetTop * scale -
            this.size / 2) /
            (e.target.height * scale)) *
            100)) /
          100 >=
        0
      ) {
        this.top =
          ((this.imgConfig.cropp.pos.y * -1) / (e.target.naturalHeight - this.size * 2)) * 100 +
          (((e.target.height * scale) / e.target.naturalHeight) *
            100 *
            (((e.pageY -
              ($innerWindow.height() - $el.height() * scale) / 2 -
              e.target.offsetTop * scale -
              this.size / 2) /
              (e.target.height * scale)) *
              100)) /
            100;
      }
      this.left =
        ((this.imgConfig.cropp.pos.x * -1) / (e.target.naturalWidth - this.size * 2)) * 100 +
        (((e.target.width * scale) / e.target.naturalWidth) *
          100 *
          (((e.pageX - ($innerWindow.width() - $el.width() * scale) / 2 - e.target.offsetLeft * scale) /
            (e.target.width * scale)) *
            100)) /
          100;
    },
    giveMeImagePlease(path) {
      let multibookMainType = this.$store.getters.multibookType;

      // if (this.$store.getters.realMultibookType) {
      //   multibookMainType = this.$store.getters.realMultibookType;
      // }
      // console.log(`__staticDir/${multibookMainType}/${path}`);
      // console.log(`${multibookMainType}`);
      return require(`__staticDir/${multibookMainType}/${path}`);
    },
    objTest(obj) {
      if (Object.entries(obj).length === 0 && obj.constructor === Object) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {},
};
</script>
<style lang="sass" scoped>
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'

.cropp-image
  background-size: contain
  background-repeat: no-repeat
  // max-width: 1920px
  // max-height: 1080px
  // overflow: hidden
  .cropped-image
    object-fit: none
    padding: 0
    cursor: zoom-in
  .zoomed-image
    object-fit: none
    padding: 0
</style>
